import { mapStateToProps } from '@segurosvoluntarios_vel/commons-services';
import { AppState } from 'src/app/store/state/app.state';
import { createSelector } from '@ngrx/store';
import { ContenidoState } from 'src/app/store/state/content.state';
import { ContenidoDePagos } from 'src/app/pago/models/ContenidoDePagos.model';
import { ContenidoDeEstadoDePago } from 'src/app/pago/models/ContenidoDeEstadoDePago.model';

const selectFeature = (appState: AppState): ContenidoState =>
  appState.contenido;

export const selectContenido = createSelector(
  selectFeature,
  (contentState: ContenidoState): ContenidoDePagos =>
    mapStateToProps(contentState.contenido)
);

export const selectContenidoEstadosDePago = createSelector(
  selectContenido,
  (contentState: ContenidoDePagos): ContenidoDeEstadoDePago[] =>
    contentState ? mapStateToProps(contentState.contenidoEstados) : []
);
